'use strict';

const dialogRegistry = require('../../../../dialogs/dialog.registry')
const {ClientWarehouseInsertDialogData} = require("../../../../dialogs/warehouse/client/ClientWarehouseInsertDialogData");

module.exports = (app) => app.directive('insertIntoWarehouseButton', /* @ngInject */ () => {
    return {
        restrict: 'E',
        scope: {
            receiptId: '@',
            receiptItemId: '@',
            orderItemId: '@',
            // article details
            supplierId: '@',
            supplierArticleNumber: '@',
            manufacturerName: '@',
            manufacturerArticleNumber: '@',
            articleNumberCustomer: '@',
            productName: '@',
            productDescription: '@',
            orderUnit: '@',
            contentUnit: '@',
            contentUnitsPerOrderUnit: '@',

            // quantity
            quantity: '@',
            quantityStored: '@',

            //
            stockDisplayId: '@'
        },
        templateUrl: `./${BUILD_PATH}/insert-into-warehouse-btn.directive.tmpl.html`,
        controller: /* @ngInject */ function ($scope, dialogService, translationService) {

            $scope.openDialog = openDialog;
            $scope.data = {
                show: false
            };

            init();

            function init() {
                const quantityStored = +$scope.quantityStored.replace(',', '.');
                const quantityShipped = +$scope.quantity.replace(',', '.');
                $scope.data.show = quantityStored < quantityShipped;
            }

            async function openDialog() {

                const quantityStored = +$scope.quantityStored.replace(',', '.');
                const data = new ClientWarehouseInsertDialogData(
                    $scope.supplierId,
                    $scope.supplierArticleNumber,
                    $scope.productName,
                    $scope.productDescription,
                    $scope.orderUnit,
                    $scope.contentUnit,
                    +$scope.contentUnitsPerOrderUnit.replace(',', '.'),
                    +$scope.quantity.replace(',', '.') - quantityStored,
                    +$scope.receiptId.replace(',', '.'),
                    +$scope.receiptItemId.replace(',', '.'),
                    +$scope.orderItemId.replace(',', '.'),
                    $scope.manufacturerName,
                    $scope.manufacturerArticleNumber,
                    $scope.articleNumberCustomer
                )

                const title = _('Produkt einlagern');
                const config = {
                    style: {
                        width: '60vw',
                        'max-width': '60vw',
                        height: '70vh',
                        'max-height': '70vh',
                    },
                    title: translationService.translate(title)
                }
                dialogService.open(
                    dialogRegistry.CLIENT_WAREHOUSE_INSERT.templatePath,
                    dialogRegistry.CLIENT_WAREHOUSE_INSERT.id,
                    data,
                    config
                ).then(
                    /**
                     * @param remainingQuantity {number | null}
                     */
                    (remainingQuantity) => {
                        if(remainingQuantity !== null) {
                            if($scope.stockDisplayId) {
                                const el = document.getElementById($scope.stockDisplayId);
                                if(el) {
                                    const quantityStored = (+$scope.quantity.replace(',', '.') - remainingQuantity).toString();
                                    el.innerText = quantityStored;
                                    $scope.quantityStored = quantityStored;
                                    init();
                                    $scope.$apply();
                                }
                            } else {
                                window.reloadContent()
                            }
                        }
                    }
                );

            }
        }
    };
})
